import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../../Univ.js'
function EditSurgeryType() {
    const {id} = useParams();
    const [typeData, settypeData] = useState({
        "type": '',
        "amount": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-surgery-type/' + id)
                .then(function (response) {
                    settypeData({
                        type: response.data.type,
                        amount: response.data.amount,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        settypeData({
            ...typeData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('type', typeData.type);
        _formData.append('amount', typeData.amount);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-surgery-type/' + id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/surgery-type/');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Surgery Type</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="category" className="form-label">Type</label>
                                    <input type="text" className="form-control" name="type" value={typeData.type}
                                           onChange={handleChange} id="type"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="amount" className="form-label">Amount</label>
                                    <input type="number" className="form-control" name="amount" value={typeData.amount}
                                           onChange={handleChange} id="amount"/>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditSurgeryType;